import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { GetState, getCurrenLang } from '../../redux/selector';
import { BreadcrumbAnt } from '../../utils/routers/Breadcrumb';
import { InviteHcp } from '../../components/invite/InviteHcp';
import styles from '../styles.module.css';
import useCheckRole from '../../hooks/useCheckRole';
import { path } from '../../utils';
import { MainTitle } from '../../common';
import { LIST_TYPE } from '../../utils/enums';
import { initialPage } from '../../utils/helper';

const InviteHCPPage = (): ReactElement => {
  const t: any = useSelector<GetState>((state) => getCurrenLang(state));
  const invite_hcp = t?.title.invite_hcp;
  const hcp_list = t?.title.hcp_list;

  const { isAdmin } = useCheckRole();

  // Breadcrumb path
  const routes = [
    {
      path: isAdmin
        ? `${path.adminDashboardList}?category=${LIST_TYPE.HCP_ADMIN}&page=${initialPage}`
        : `${path.dashboardList}?category=${LIST_TYPE.HCP}&page=${initialPage}`,
      breadcrumbName: hcp_list,
    },
    {
      path: invite_hcp,
      breadcrumbName: invite_hcp,
    },
  ];

  return (
    <div className={styles.main__container}>
      <BreadcrumbAnt currentRoutes={routes} />
      <div className={styles['main__flex-wrapper']}>
        {/* Invite HCP */}
        <div className={styles['left-section']}>
          <MainTitle title={invite_hcp} />
          <InviteHcp />
          {/* {(userPermissions.length > 0 || isAdmin) && <InviteHcp />} */}
        </div>
      </div>
    </div>
  );
};

export default InviteHCPPage;
